<template>
    <div class="card card-body">
        <h2>Beliebte Marken</h2>
        <table class="table table-sm table-hover text-lg">
            <tr v-for="brand in brands">
                <td class="py-2">{{ brand.name }}</td>
                <td class="text-right py-2"><span class="text-monospace">{{ brand.impressions }}</span><i class="fas fa-eye ml-1" /></td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        brands: Array
    },
}
</script>
